import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '../components';
import BlockTabs from '../BlockTabs';
import ChartContainer from '../metrics/DataByDayChart';
import { useGetAppDataByDayQuery } from '../../api/appApiSlice';
import TableContainer from '../metrics/TableContainer';

const DataByDay = ({appId, filter}) => {
	const { t } = useTranslation();
  const { data = [], isSuccess, isLoading, refetch } = useGetAppDataByDayQuery({appId, filter})
  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && !isSuccess), retry: refetch }

  return(
    <BlockTabs title={t("dataByDay.title")} defaultActiveKey="chart">
      <Loader {...loaderProps} key="table" title="table">
        <TableContainer data={data} />
      </Loader>
      <Loader {...loaderProps} key="chart" title="chart" >
        <ChartContainer data={data} />
      </Loader>
    </BlockTabs>
  )
}

export default DataByDay